import { Col } from '@rematter/ui-web';
import { LucideMapPin } from 'lucide-react';

import { SettingsContent } from '~/modules/settings/_components/_shared/SettingsContent';
import { useTranslations } from '~/modules/settings/i18n/useTranslations';

export const CustomerPortalUserLocationsTab = () => {
  const t = useTranslations();

  return (
    <SettingsContent
      size="full"
      className="@CustomerPortalUserLocationsTab h-full"
    >
      <Col className="h-full items-center justify-center">
        <LucideMapPin size={48} className="text-neutral/20" />
        <span className="mt-4 text-lg font-medium text-neutral/50">
          {t.customerPortal.userDetails.locations.title}
        </span>
        <span className="text-sm text-neutral/40">
          {t.customerPortal.userDetails.locations.subtitle}
        </span>
      </Col>
    </SettingsContent>
  );
};
